import { registerTab } from "lib/@components/tabs"
import { ASSET_TAB_ID } from "routes/asset-register/asset-register"
import { createEvent } from "library/local-events/index.mjs"
import { Mapping } from "routes/asset-register/plugins/asset-mapping/mapping"
import { hasDemand } from "lib/authorization/has-demand"
import { TieredAccessGate } from "minimals-template/components/guards/tiered-access-gate"
import { Box, Container } from "@mui/material"
import { NewTabChip } from "lib/@components/tabs/new-tab-chip"
import { Frag } from "lib/@components/slot/frag"
import "./feature-flag-mobiliser"
import { Feature, isEnabled } from "lib/@components/feature"
import { FEATURE_FLAG_MOBILISER } from "routes/asset-register/plugins/asset-mapping/feature-flag-mobiliser"
import { FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING } from "routes/asset-register/plugins/asset-mapping/feature-flag-mobiliser-advanced-mapping.runtime"

const bodyTextSfg20 = [
    "Save time with our intelligent AI mapping feature. It suggests matches for you and intelligently maps assets.",
    "Contact your Account Manager, contact us on +44 1768 720736 or sales@sfg20.co.uk",
]

registerTab({
    tab: ASSET_TAB_ID,
    id: "types",
    title: (
        <Box display="flex" alignItems="center" gap={1}>
            <Box component="span">SFG20 Mobiliser</Box>
            <Feature feature={FEATURE_FLAG_MOBILISER} fallback={<NewTabChip />}>
                <Frag />
            </Feature>
        </Box>
    ),
    disabled: (context) =>
        isEnabled(FEATURE_FLAG_MOBILISER_ADVANCED_MAPPING) && isEnabled(FEATURE_FLAG_MOBILISER) && !context.hasAssets,
    disabledTooltipText: "Upload a register to enable Mobiliser.",
    content: (
        <Feature
            feature={FEATURE_FLAG_MOBILISER}
            fallback={
                <Container>
                    <TieredAccessGate title="SFG20 Mobiliser" bodyText={bodyTextSfg20} logEvent={"sfg20-mobiliser"} />
                </Container>
            }
        >
            <Mapping $lazy mappingType="sfg20" priority={100} />
        </Feature>
    ),
    demands: "feature-assets",
    predicate() {
        return hasDemand("mapAssets")
    },
})

registerTab({
    tab: ASSET_TAB_ID,
    id: "manual-mapping",
    title: "Asset Mapping",
    content: <Mapping $lazy mappingType="manual" priority={50} />,
    demands: "feature-assets",
    predicate() {
        return hasDemand("mapAssets") && !isEnabled(FEATURE_FLAG_MOBILISER)
    },
})

export const MappingUpdated = createEvent("MappingUpdated")
